import { useTelescopeContext } from "@hubble/telescope";
import { createSignal } from "solid-js";
import { useDenominationsGridWebstoreTelescopeContext } from "../context/denominations_grid";

function RupeeIcon() {
  return <span class="text-para-3-semi-bold text-text-normal-primary">₹</span>;
}

export function CustomAmountInput() {
  const { components } = useTelescopeContext();
  const {
    customAmountInputDebounce,
    defaultAmountInCustomInput,
    internalState,
  } = useDenominationsGridWebstoreTelescopeContext();

  const { dryRunErrorMessage } = internalState;
  const isInvalid = () => dryRunErrorMessage() != null;

  // Format initial value with Indian number formatting
  const [inputValue, setInputValue] = createSignal(
    defaultAmountInCustomInput
      ? defaultAmountInCustomInput.toLocaleString("en-IN")
      : ""
  );

  const handleChange = (value: string) => {
    // Remove all non-numeric characters immediately

    // // If empty, set empty string
    if (value === "") {
      setInputValue("");
      return;
    }

    // Convert to number
    const numValue = parseInt(value);

    // Debounce the actual numeric value
    if (!isNaN(numValue)) {
      // Format for display with Indian number formatting
      const formattedValue = numValue.toLocaleString("en-IN");
      setInputValue(formattedValue);
      customAmountInputDebounce(numValue);
    }
  };

  return (
    <components.Input
      id="custom-amount-input"
      value={inputValue()}
      onChange={handleChange}
      placeholder="Enter amount"
      type="number"
      size={44}
      state={isInvalid() ? "error" : "default"}
      helperText={isInvalid() ? (dryRunErrorMessage() ?? "") : undefined}
      leadIcon={RupeeIcon}
    />
  );
}
